import useFetchByParams from 'shared/hooks/useFetchByParams';
import { useRequestQuery } from 'shared/hooks/useRequest';
import { Option } from '../models';
import { useMemo } from 'react';
import { fetchAllOptions, selectAllOptions, selectOptionLoading } from 'features/products/store/option.slice';
import { QueryParams } from 'shared/types';
import { optionService } from '../services';

export const useOptionsQuery = (query?: QueryParams) => {
  return useMemo(() => {
    const queryParams = { ...query, isActive: 1 };

    return [queryParams];
  }, []);
};

export const useOptions = (query: QueryParams) => {
  return useFetchByParams<Option[]>({
    action: fetchAllOptions,
    dataSelector: selectAllOptions,
    loadingSelector: selectOptionLoading,
    params: query,
  });
};

export const useOptionsRequest = (initialParams?: QueryParams) => {
  const action = async (params?: QueryParams): Promise<Option[]> => {
    if (params && 'productTypeId[]' in params) {
      const response = await optionService.getOptions({ ...params, isActive: 1 });
      return response;
    }
    return [];
  };

  return useRequestQuery<QueryParams, Option[]>({
    action: action,
    defaultValue: [],
    params: initialParams,
    autoFetch: true,
  });
};
